import { render, staticRenderFns } from "./OneOrder.vue?vue&type=template&id=379279dd&scoped=true&"
import script from "./OneOrder.vue?vue&type=script&lang=js&"
export * from "./OneOrder.vue?vue&type=script&lang=js&"
import style0 from "./OneOrder.vue?vue&type=style&index=0&id=379279dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379279dd",
  null
  
)

export default component.exports